jQuery(document).ready(function($) {

	$('.insights-accordion--link-a').on('click',function(e){
		e.preventDefault();
		$( $(this).attr('href') ).toggleClass('is-collapsed');
	});

});